// Copied from zod 4.4.3 (zod/v4/core/regexes.js `email`), the rule behind the
// intake-lead API schema `z.string().trim().email()`. Kept inline so the widget
// bundle does not import zod; intake-email.test.ts checks the two agree.
const EMAIL_RE =
  /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;

/** Common email domain typos → suggested correction (mailcheck-style). */
const DOMAIN_TYPOS: Record<string, string> = {
  'gamil.com': 'gmail.com',
  'gmial.com': 'gmail.com',
  'gmai.com': 'gmail.com',
  'gmail.co': 'gmail.com',
  'gmail.con': 'gmail.com',
  'gnail.com': 'gmail.com',
  'hotmal.com': 'hotmail.com',
  'hotmial.com': 'hotmail.com',
  'hotmail.co': 'hotmail.com',
  'outlok.com': 'outlook.com',
  'outllok.com': 'outlook.com',
  'yahooo.com': 'yahoo.com',
  'yaho.com': 'yahoo.com',
};

export function suggestEmailCorrection(email: string): string | null {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf('@');
  if (at < 1) return null;
  const local = trimmed.slice(0, at);
  const domain = trimmed.slice(at + 1);
  const corrected = DOMAIN_TYPOS[domain];
  if (!corrected) return null;
  return `${local}@${corrected}`;
}

export function isValidEmail(email: string): boolean {
  return EMAIL_RE.test(email.trim());
}
